import React from 'react';
import { Button, ButtonToolbar, Col, Container, Row } from 'react-bootstrap';
import { File } from '../../../form';
import { InconsistenciesContext } from 'components/app/app';

export type FooterType = {
  name: string | '';
  email: string | '';
  phone: string | '';
};

export type FooterProps = {
  controlIdFile: string;
  supportedFormat: string;
  resetForm: () => void;
  onSubmit: () => void;
  submitting?: boolean;
  values: any;
};

export const Footer: React.FC<React.PropsWithChildren<FooterProps>> = ({
  controlIdFile,
  supportedFormat,
  resetForm,
  onSubmit,
  submitting = false,
  values,
}) => {
  return (
    <InconsistenciesContext.Consumer>
      {() => {
        return (
          <Container className="footer">
            <Row>
              <Col>
                <File controlId={controlIdFile} accept={supportedFormat} required={true}></File>
              </Col>
              <Col xs={{ span: 12 }} lg={{ span: 2, offset: 4 }}>
                <ButtonToolbar className="form-actions">
                  <Button className="me-2" onClick={() => resetForm()} variant="light" type="button">
                    Clear
                  </Button>
                  <Button variant={values.forceWarning ? 'warning' : 'primary'} type="submit" disabled={submitting} onClick={onSubmit}>
                    {values.forceWarning ? 'Submit(Warnings)' : 'Submit'}
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
          </Container>
        );
      }}
    </InconsistenciesContext.Consumer>
  );
};
